module.exports = __webpack_public_path__ + "assets/img/shenzhen.1f1b96f1.png";